import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as actionUrl from "../../store/actions";
import { useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import CustomToast from "../../components/Toast";
const auctionCenterIdFromURI =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[4]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[4]
      )
    : "";
const userId =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[3]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[3]
      )
    : "";
const userRoleCode = atob(localStorage.getItem("argument6"));
const ViewBidBook = (modalRight, open, setOpen) => {
  const dispatch = useDispatch();
  const [markCode, setmarkCode] = useState("");

  const bidBookData = useSelector(
    (state) => state?.englishAuctionReducer?.bidBook?.responseData
  );
  const lotDropdownData = useSelector(
    (state) => state?.englishAuctionReducer?.lotdropdowndata?.responseData
  );
  const sessionTimeList = useSelector(
    (state) => state?.englishAuctionReducer?.sessionTimeList?.responseData
  );
  const loaderBidBook = useSelector(
    (state) => state?.englishAuctionReducer?.loading
  );
  const gradeDropdownData = useSelector(
    (state) => state?.grade?.data?.responseData
  );
  const markDropdownData = useSelector(
    (state) =>
      state?.markReducer?.fetchMarkDetailsByAuctionCenterId?.responseData
  );

  const [exportType, setexportType] = useState("");
  const [searchGradeCode, setSearchGradeCode] = useState("");
  const [searchlotNo, setsearchlotNo] = useState("");
  const [searchlotStatus, setsearchlotStatus] = useState("");
  const [searchsessiontime, setsearchsessiontime] = useState("");
  const resetForm = () => {
    setsearchlotNo("");
    setSearchGradeCode("");
    setmarkCode("");
    setsearchsessiontime("");
    setsearchlotStatus("");
    dispatch(actionUrl.fetchBidBookSuccess([]));
  };
  const handleSessionTimeChange = (e) => {
    if (
      e.target.value != undefined &&
      e.target.value != "" &&
      e.target.value != null
    ) {
      let selectedValue = e.target.value;
      setsearchsessiontime(selectedValue);
      let sesId = selectedValue.split("$$")[0];
      dispatch(actionUrl.fetchLotRequest(sesId));
    } else {
      setsearchsessiontime("");
    }
  };
  const handleSubmit = (event) => {
    if (!searchsessiontime.trim()) {
      CustomToast.error("Please select Session Time");
      return;
    }
    let payloadData = {
      auctionDetailId: null,
      commonUserId: userId,
      lotNo: searchlotNo,
      lotStatus: searchlotStatus,
      markId: markCode,
      gradeId: searchGradeCode,
      sessionTime: searchsessiontime.split("$$$")[1],
      sessionDetailId: searchsessiontime.split("$$$")[0],
      auctionItemDetailId: null,
      isLiveBidBook: 0,
      auctionCenterId: auctionCenterIdFromURI,
    };
    dispatch(actionUrl.fetchBidBookRequest(payloadData));
  };

  useEffect(() => {
    dispatch(
      actionUrl.fetchGradeRequest({ auctionCenterId: auctionCenterIdFromURI })
    );
    dispatch(
      actionUrl.fetchMarkDetailsByAuctionCenterId({
        auctionCenterId: auctionCenterIdFromURI,
      })
    );
    dispatch(
      actionUrl.fetchSessionTimeRequest({
        auctionCenterId: auctionCenterIdFromURI,
        auctionTypeMasterId: 2,
      })
    );
  }, []);

  const bidBookExportData = useSelector(
    (state) => state?.englishAuctionReducer?.bidBookExport?.responseData
  );
  const handleExport = (exportType) => {
    setexportType("");
    let payloadData = {
      auctionDetailId: null,
      commonUserId: userId,
      lotNo: searchlotNo,
      lotStatus: searchlotStatus,
      markId: markCode,
      gradeId: searchGradeCode,
      sessionTime: searchsessiontime.split("$$$")[1],
      sessionDetailId: searchsessiontime.split("$$$")[0],
      auctionItemDetailId: null,
      isLiveBidBook: 0,
      auctionCenterId: auctionCenterIdFromURI,
      isExport: 1,
      exportType: exportType,
    };
    dispatch(actionUrl.fetchBidBookRequest(payloadData));
    setexportType(exportType);
  };
  const downloadFile = (base64String, fileName, contentType) => {
    // Convert the base64 string to a Blob
    const byteCharacters = atob(base64String);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });

    // Create a link element, hide it, direct download
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);

    // Create a DOMString representing the blob and point the link element towards it
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;

    // Trigger the download
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
  useEffect(() => {
    if (
      bidBookExportData != null &&
      bidBookExportData != undefined &&
      bidBookExportData != []
    ) {
      let contentType =
        exportType == "pdf"
          ? "application/pdf"
          : exportType == "excel"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "";
      if(contentType!="" && contentType!=undefined)
      downloadFile(
        bidBookExportData?.exported_file,
        "View Bid Book",
        contentType
      );
    }
  }, [bidBookExportData]);
  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="row align-items-end">
            <div className="col-md-4">
              <div className="FormGroup">
                <label>Session Time</label>
                <label className="errorLabel"> * </label>
                <select
                  className="form-control select-form"
                  value={searchsessiontime}
                  onChange={(e) => handleSessionTimeChange(e)}
                >
                  <option value="">Select Session time </option>
                  {sessionTimeList?.map((state) => (
                    <option
                      key={state.auctionSessionDetailId}
                      value={
                        state.auctionSessionDetailId + "$$$" + state.SessionTime
                      }
                    >
                      {state.SessionTime}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {userRoleCode == "BUYER" ||
            userRoleCode == "ASSOCIATEBUYER" ||
            userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
            userRoleCode == "TAOUSER" ||
            userRoleCode == "TEABOARDUSER" ? (
              <>
                <div className="col-md-4">
                  <div className="FormGroup">
                    <label>Grade Name</label>
                    <select
                      className="form-control select-form"
                      value={searchGradeCode}
                      onChange={(e) => setSearchGradeCode(e.target.value)}
                    >
                      <option value="">Select Grade Name </option>
                      {gradeDropdownData?.map((state) => (
                        <option key={state.gradeId} value={state.gradeId}>
                          {state.gradeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="FormGroup">
                    <label>Mark Name</label>
                    <select
                      className="form-control select-form"
                      value={markCode}
                      onChange={(e) => setmarkCode(e.target.value)}
                    >
                      <option value={""}>Select Mark Name</option>

                      {markDropdownData != [] &&
                        markDropdownData?.map((state) => (
                          <option key={state.markId} value={state.markId}>
                            {state.markName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {!(
              userRoleCode == "BUYER" ||
              userRoleCode == "ASSOCIATEBUYER" ||
              userRoleCode == "POSTAUCTIONASSOCIATEBUYER"
            ) ? (
              <>
                <div className="col-md-4">
                  <div className="FormGroup">
                    <label>Lot No</label>
                    <select
                      className="form-control select-form"
                      value={searchlotNo}
                      onChange={(e) => setsearchlotNo(e.target.value)}
                    >
                      <option value="">Select Lot No </option>
                      {lotDropdownData?.map((state) => (
                        <option key={state.lotNo} value={state.lotNo}>
                          {state.lotNo}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {userRoleCode == "AUCTIONEER" ||
            userRoleCode == "ASSOCIATEAUCTIONEER" ||
            userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
            userRoleCode == "SELLER" ||
            userRoleCode == "WAREHOUSEUNIT" ||
            userRoleCode == "WAREHOUSE" ? (
              <>
                <div className="col-md-4">
                  <div className="FormGroup">
                    <label>Lot Status</label>
                    <select
                      className="form-control select-form"
                      value={searchlotStatus}
                      onChange={(e) => setsearchlotStatus(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="2">Sold</option>
                      <option value="3">Unsold</option>
                      <option value="0">Pending</option>
                    </select>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="col-md-12">
              <div className="BtnGroup">
                <button className="SubmitBtn" onClick={handleSubmit}>
                Search
                </button>
                <button className="Clear" onClick={resetForm}>
                  Clear
                </button>
              </div>
            </div>
          </div>
          {loaderBidBook ? (
            <>
              <div className="">
                <ThreeDots
                  visible={true}
                  height="80"
                  width="80"
                  color="#4fa94d"
                  radius="9"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            </>
          ) : (
            <table id="example" class="stripe- row-border order-column table ">
              <thead>
                <tr>
                  {userRoleCode == "TAOUSER" ||
                  userRoleCode == "TEABOARDUSER" ? (
                    <>
                      <th>Lot No.</th>
                      <th>Mark</th>
                      <th>Grade</th>
                      <th>Inv. No.</th>
                      <th>Server Bid No.</th>
                      <th>Bid Price</th>
                      <th>Bid Date & Time</th>
                      <th>Bid Qty.</th>
                      <th>Share Qty.</th>
                      <th>Session Time</th>
                      <th>Buy Qty. @ HBP</th>
                      <th>Status</th>
                    </>
                  ) : userRoleCode == "BUYER" ||
                    userRoleCode == "ASSOCIATEBUYER" ||
                    userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ? (
                    <>
                      <th>Lot No.</th>
                      <th>Origin</th>
                      <th>Mark</th>
                      <th>Grade</th>
                      <th>Buy Qty.</th>
                      <th>Share Qty.</th>
                      <th>Buy Qty. @ HBP</th>
                      <th>Bid Price</th>
                      <th>Auto Bid Limit</th>
                      <th>Limit Price</th>
                      <th>MAQ@HBP</th>
                      <th>Server Bid No.</th>
                      <th>Status</th>
                      <th>Bid Date & Time</th>
                    </>
                  ) : userRoleCode == "AUCTIONEER" ||
                    userRoleCode == "ASSOCIATEAUCTIONEER" ||
                    userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
                    userRoleCode == "SELLER" ||
                    userRoleCode == "WAREHOUSEUNIT" ||
                    userRoleCode == "WAREHOUSE" ? (
                    <>
                      <th>Invoice No.</th>
                      <th>Lot No.</th>
                      <th>Grade</th>
                      <th>Mark</th>
                      <th>Buy Share</th>
                      <th>Share Qty.</th>
                      <th>Bid Price</th>
                      <th>Buy Share @ HBP</th>
                      <th>Bid Date & Time</th>
                      <th>Bid Status</th>
                      <th>Lot Status</th>
                    </>
                  ) : (
                    ""
                  )}
                </tr>
              </thead>
              {bidBookData &&
                bidBookData.map((col, index) => (
                  <tr>
                    {userRoleCode == "BUYER" ||
                    userRoleCode == "ASSOCIATEBUYER" ||
                    userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ? (
                      <>
                        <td> {col.lotNo}</td>
                        <td> {col.origin}</td>
                        <td> {col.mark}</td>
                        <td> {col.grade}</td>
                        <td> {col.buyQty}</td>
                        <td> {col.shareQty}</td>
                        <td> {col.buyQtyHBP}</td>
                        <td> {col.bidPrice}</td>
                        <td> {col.autoBidlimit}</td>
                        <td> {col.limitPrice}</td>
                        <td> {col.minimumNoOfPackage}</td>
                        <td> {col.serverBidNo}</td>
                        <td> {col.status}</td>
                        <td> {col.bidDateTime}</td>
                      </>
                    ) : userRoleCode == "AUCTIONEER" ||
                      userRoleCode == "ASSOCIATEAUCTIONEER" ||
                      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
                      userRoleCode == "SELLER" ||
                      userRoleCode == "WAREHOUSEUNIT" ||
                      userRoleCode == "WAREHOUSE" ? (
                      <>
                        <td> {col.invoiceNo}</td>
                        <td> {col.lotNo}</td>
                        <td> {col.grade}</td>
                        <td> {col.mark}</td>
                        <td> {col.buyQty}</td>
                        <td> {col.shareQty}</td>
                        <td> {col.bidPrice}</td>
                        <td> {col.buyQtyHBP}</td>
                        <td> {col.bidDateTime}</td>
                        <td> {col.bidstatus}</td>
                        <td> {col.lotStatus}</td>
                      </>
                    ) : userRoleCode == "TAOUSER" ||
                      userRoleCode == "TEABOARDUSER" ? (
                      <>
                        <td> {col.lotNo}</td>
                        <td> {col.mark}</td>
                        <td> {col.grade}</td>
                        <td> {col.invoiceNo}</td>
                        <td> {col.serverBidNo}</td>
                        <td> {col.bidPrice}</td>
                        <td> {col.bidDateTime}</td>
                        <td> {col.buyQty}</td>
                        <td> {col.shareQty}</td>
                        <td>{col.sessionTime}</td>
                        <td> {col.buyQtyHBP}</td>
                        <td>{col.bidstatus}</td>
                      </>
                    ) : (
                      ""
                    )}
                  </tr>
                ))}
            </table>
          )}
        </div>
        {bidBookData && (
          <div className="col-md-12">
            <div className="BtnGroup">
              <button class="SubmitBtn" onClick={() => handleExport("pdf")}>
                <i class="fa fa-file-pdf"></i>
              </button>
              <button class="SubmitBtn" onClick={() => handleExport("excel")}>
                <i class="fa fa-file-excel"></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewBidBook;
